type AsyncFunction<T> = () => Promise<T>;
type SyncFunction<T> = () => T;
type ShowToastFn = (summary: string, detail?: string) => void;

export interface ApiError {
  response?: {
    status: number;
    data?: {
      message?: string;
      error?: string;
    };
  };
}

export async function handleError<T>(
  fn: AsyncFunction<T>,
  errorMessage: string = 'An error occurred',
  defaultValue?: (error?: any) => T,
  showToast?: ShowToastFn
): Promise<T> {
  try {
    return await fn();
  } catch (error) {
    console.error(errorMessage, error);

    const apiError = error as ApiError;
    const backendError = apiError.response?.data?.error || apiError.response?.data?.message;
    const finalErrorMessage = backendError || errorMessage;

    if (showToast) {
      showToast(finalErrorMessage);
    }

    if (defaultValue !== undefined) {
      return defaultValue(error);
    }
    throw error;
  }
}

export function handleSyncError<T>(
  fn: SyncFunction<T>,
  errorMessage: string = 'An error occurred',
  defaultValue?: () => T,
  showToast?: ShowToastFn
): T {
  try {
    return fn();
  } catch (error) {
    console.error(errorMessage, error);

    if (showToast) {
      showToast(errorMessage);
    }

    if (defaultValue !== undefined) {
      return defaultValue();
    }
    throw error;
  }
}

export function logError(error: unknown, message: string = 'An error occurred'): void {
  console.error(message, error);
}